const serializeForm = function(form) {
    let obj = {};
    let formData = new FormData(form);
    for (let key of formData.keys()) {
        if (key.endsWith('[]')) {
            obj[key.replace('[]', '')] = formData.getAll(key);
        } else {
            obj[key] = formData.get(key);
        }
    }
    return obj;
};

const headerDesc = document.querySelector('.page-header__desc');
const previouslyVotedCont = document.querySelector('.previously-voted-cont');
const nomineeForm = document.getElementById('nominee-form');
const userForm = document.getElementById('user-form');
const nextBtn = document.getElementById('next-btn');
const changeSelection = document.getElementById('change-selection');
const acquiredSubmit = document.getElementById('acquired-submit');
const nomineeSelections = document.getElementById('nominee-selections');
const nominees = document.querySelectorAll('#nominee-cont .nominee-checkbox');
const footerCTA = document.querySelector('.site-footer__cta');
const max = 2;
let maxVote = false;

// Limit number of votes to 2 for multi-select polls
for (var i = 0; i < nominees.length; i++) {
    nominees[i].onclick = limitCheck;
    function limitCheck(event) {
        const selectedNominees = document.querySelectorAll('#nominee-cont .nominee-checkbox:checked');
        const button = event.target.parentNode.querySelector('.button');
        if (selectedNominees.length >= max + 1) {
            return false;
        } else {
            if (nominees[0].type === 'radio') {
                Array.from(document.querySelectorAll('.vote-select')).forEach(function(el) { 
                    el.classList.remove('inactive');
                    el.textContent = 'Select';
                });
                button.classList.add('inactive');
                button.textContent = 'Selected';
            } else {
                button.classList.toggle('inactive');
                button.textContent == 'Select' ? button.textContent = 'Selected' : button.textContent = 'Select';
            }

            // clone element to selected nominees box
            nomineeSelections.innerHTML = '';
            selectedNominees.forEach(function(nominee) {
                const nomineeCont = nominee.parentNode.parentNode;
                const nomineeClone = nomineeCont.cloneNode(true);
                nomineeClone.querySelector('a.arrow').remove();
                nomineeClone.querySelector('input').remove();
                nomineeClone.querySelector('.nominee-photo-cont').classList.add('selected');
                nomineeClone.querySelector('a.button').classList.remove('vote-select');
                nomineeClone.querySelector('a.button').setAttribute('onclick','return false;');
                nomineeSelections.appendChild(nomineeClone);
            });
        }

        // Set disabled class on all non-checked nominees if max are selected
        if (selectedNominees.length == max) {
            nominees.forEach(function(nominee) {
                if (!nominee.checked) {
                    nominee.parentNode.classList.add('disabled');
                }
            });
        } else {
            nominees.forEach(function(nominee) {
                nominee.parentNode.classList.remove('disabled');
            });
        }

        // Show/hide the next button
        if (selectedNominees.length < 1) {
            if (nextBtn) {
                nextBtn.classList.add('disabled');
            } else {
                acquiredSubmit.disabled = true;
            }
        } else {
            if (nextBtn) {
                nextBtn.classList.remove('disabled');
            } else {
                acquiredSubmit.disabled = false;
            }
        }
    }
}

function submitVote(form) {
    const voteStatus = document.getElementById('vote-status');
    const voteError = voteStatus.querySelector('.error');
    const voteSuccess = voteStatus.querySelector('.success');
    fetch(site.ajax_url, {
        method: 'POST',
        body: new URLSearchParams({
            action: 'poll_vote',
            data: JSON.stringify(serializeForm(form)),
        }),
        headers: { 'Content-type': 'application/x-www-form-urlencoded' }
    })
    .then((response) => response.json())
    .then(function(data) {
        if (!data.voted) {
            voteError.style.display = 'block';
        } else {
            voteSuccess.style.display = 'block';
        }
        document.querySelector('.poll-cont__single').style.display = 'none';
        document.getElementsByClassName('page-header')[0].style.display = 'none';
        voteStatus.style.display = 'block';
        footerCTA.style.display = 'block';
        window.scrollTo({top: 0});
    });
}

document.addEventListener('DOMContentLoaded', function () {
    if (document.body.classList.contains('single-poll')) {
        const poll = document.querySelector('.poll-cont__single');
        const previouslyVoted = poll.dataset.voted;

        if (previouslyVoted) {
            document.body.classList.add('restricted');
            headerDesc.style.display = 'none';
            previouslyVotedCont.style.display = 'block';
        }

        // Trigger click of button's parent label
        document.addEventListener('click', function(e) {
            if (!event.target.closest('.vote-select')) return;
            e.preventDefault();
            const el = e.target;
            el.parentNode.click();
        });

        // Go to user form after nominee selection
        if (nextBtn) {
            nextBtn.addEventListener('click', function handleClick(e) {
                e.preventDefault();
                if (!nextBtn.classList.contains('disabled')) {
                    nomineeForm.style.display = 'none';
                    userForm.style.display = 'block';
                    window.scrollTo({top: 0});
                }
            });
        }

        if (changeSelection) {
            changeSelection.addEventListener('click', function handleClick(e) {
                e.preventDefault();
                nomineeForm.style.display = 'block';
                userForm.style.display = 'none';
                window.scrollTo({top: 0});
            });
        }
    }
}, false);

jQuery(document).ready(function($) {
    $('#submit-vote').validate({
        rules: {
            fname: 'required',
            email: {
                required: true,
                email: true
            }
        },
        messages: {
            fname: 'Please enter your first name',
            email: 'Please enter a valid email address'
        },
        // highlight: function (element, errorClass, validClass) {
        //     console.log($(element));
        //     $(element).parents('label').addClass('error');
        // },
        // unhighlight: function (element, errorClass, validClass) {
        //     console.log($(element));
        //     $(element).parents('label').removeClass('error');
        // },
        submitHandler: function(form) {
            submitVote(form);
            return false;
        }
    });
});